import React, {
    useState,
    useEffect,
    ChangeEvent,
    useContext,
    useRef,
} from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Text from '../../components/text/Text'
import SquareCheckBox from '../../components/checkBox/SquareCheckBox'

import { getCommerceInfo } from '../../services/commerce'

import arrowBack from '../../assets/icons/icons-arrow-back.svg'
// import info from '../../assets/icons/icon-info-circle.svg'
import ecoFriendlyIcon from '../../assets/icons/icons-eco-friend.svg'

import { labels, onlineConfig } from '../../labels'
import './StoreConfigurationScreen.css'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import routes from '../../router/routes'

interface Day {
    dayLetter: string
    day: string
    setDaySelected: () => void
    isSelected: boolean
    dateDesde: string
    dateHasta: string
    setDateDesde: (value: string) => void
    setDateHasta: (value: string) => void
}

interface DayReception {
    dayLetter: string
    day: string
    setDaySelected: () => void
    isSelected: boolean
    dateDesde: string
    dateHasta: string
}

export default function StoreConfigurationScreen() {
    const { features } = useContext(FeatureContext)
    const navigation = useNavigate()
    const state = useLocation()
    const [commerceSchedule, setCommerceSchedule] = useState<boolean>(false)
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const commerceId = user?.sEstablecimiento + user?.cLocal[0]?.sLocal
    const [logo, setLogo] = useState<string>('')
    const [storeCategory, setStoreCategory] = useState<string>('')
    const [storeDescription, setStoreDescription] = useState<string>('')
    const [descriptionDisabled, setDescriptionDisabled] =
        useState<boolean>(true)
    const [sPhoneNumber, setSPhoneNumber] = useState<string>('')
    const [phoneDisabled, setPhoneDisabled] = useState<boolean>(true)
    const [hasOnlineCommerce, setHasOnlineCommerce] = useState<boolean>(false)
    const [urlAmimarket, setUrlAmimarket] = useState<string>('')
    const [allDayDel, setAllDayDel] = useState<boolean>(false)
    const [sEmailContacto, setSEmailContacto] = useState<string>(
        user?.sEmailContacto ? user?.sEmailContacto : ''
    )
    const [hasWithdrawal, setHasWithdrawal] = useState<boolean>(false)
    const [hasDelivery, setHasDelivery] = useState<boolean>(false)
    const [ammount, setAmmount] = useState<string>('')
    const [minAmmount, setMinAmount] = useState<string>('')
    const [selectedList, setSelectedList] = useState<RegionType[]>([])
    const [hasConsumerStore, setHasConsumerStore] = useState<boolean>(false)
    const [lunAttentionHour, setLunAttentionHour] = useState<boolean>(false)
    const [lunDesde, setLunDesde] = useState<string>('')
    const [lunHasta, setLunHasta] = useState<string>('')
    const [marAttentionHour, setMarAttentionHour] = useState<boolean>(false)
    const [marDesde, setMarDesde] = useState<string>('')
    const [marHasta, setMarHasta] = useState<string>('')
    const [mierAttentionHour, setMierAttentionHour] = useState<boolean>(false)
    const [mierDesde, setMierDesde] = useState<string>('')
    const [mierHasta, setMierHasta] = useState<string>('')
    const [jueAttentionHour, setJueAttentionHour] = useState<boolean>(false)
    const [jueDesde, setJueDesde] = useState<string>('')
    const [jueHasta, setJueHasta] = useState<string>('')
    const [vieAttentionHour, setVieAttentionHour] = useState<boolean>(false)
    const [vierDesde, setVierDesde] = useState<string>('')
    const [vierHasta, setVierHasta] = useState<string>('')
    const [sabAttentionHour, setSabAttentionHour] = useState<boolean>(false)
    const [sabDesde, setSabDesde] = useState<string>('')
    const [sabHasta, setSabHasta] = useState<string>('')
    const [domAttentionHour, setDomAttentionHour] = useState<boolean>(false)
    const [domDesde, setDomDesde] = useState<string>('')
    const [domHasta, setDomHasta] = useState<string>('')
    const [lunReceptionHour, setLunReceptionHour] = useState<boolean>(false)
    const [receptionDesde, setReceptionDesde] = useState<string>('')
    const [receptionHasta, setReceptionHasta] = useState<string>('')
    const [marReceptionHour, setMarReceptionHour] = useState<boolean>(false)
    const [mierReceptionHour, setMierReceptionHour] = useState<boolean>(false)
    const [jueReceptionHour, setJueReceptionHour] = useState<boolean>(false)
    const [vieReceptionHour, setVieReceptionHour] = useState<boolean>(false)
    const [sabReceptionHour, setSabReceptionHour] = useState<boolean>(false)
    const [domReceptionHour, setDomReceptionHour] = useState<boolean>(false)
    const [deactive, setDeactive] = useState<boolean>(false)
    const [errorComerceData, setErrorComerceData] = useState<boolean>(false)
    const containerRef = useRef<HTMLDivElement>(null)

    const dateSelection: Day[] = [
        {
            dayLetter: onlineConfig.daySelectL,
            day: onlineConfig.daySelectMonday,
            setDaySelected: () => setLunAttentionHour(!lunAttentionHour),
            isSelected: lunAttentionHour,
            dateDesde: lunDesde,
            dateHasta: lunHasta,
            setDateDesde: (value: string) => setLunDesde(value),
            setDateHasta: (value: string) => setLunHasta(value),
        },
        {
            dayLetter: onlineConfig.daySelectM,
            day: onlineConfig.daySelectTuesday,
            setDaySelected: () => setMarAttentionHour(!marAttentionHour),
            isSelected: marAttentionHour,
            dateDesde: marDesde,
            dateHasta: marHasta,
            setDateDesde: (value: string) => setMarDesde(value),
            setDateHasta: (value: string) => setMarHasta(value),
        },
        {
            dayLetter: onlineConfig.daySelectM,
            day: onlineConfig.daySelectWednesday,
            setDaySelected: () => setMierAttentionHour(!mierAttentionHour),
            isSelected: mierAttentionHour,
            dateDesde: mierDesde,
            dateHasta: mierHasta,
            setDateDesde: (value: string) => setMierDesde(value),
            setDateHasta: (value: string) => setMierHasta(value),
        },
        {
            dayLetter: onlineConfig.daySelectJ,
            day: onlineConfig.daySelectThursday,
            setDaySelected: () => setJueAttentionHour(!jueAttentionHour),
            isSelected: jueAttentionHour,
            dateDesde: jueDesde,
            dateHasta: jueHasta,
            setDateDesde: (value: string) => setJueDesde(value),
            setDateHasta: (value: string) => setJueHasta(value),
        },
        {
            dayLetter: onlineConfig.daySelectV,
            day: onlineConfig.dayselectFriday,
            setDaySelected: () => setVieAttentionHour(!vieAttentionHour),
            isSelected: vieAttentionHour,
            dateDesde: vierDesde,
            dateHasta: vierHasta,
            setDateDesde: (value: string) => setVierDesde(value),
            setDateHasta: (value: string) => setVierHasta(value),
        },
        {
            dayLetter: onlineConfig.daySelectS,
            day: onlineConfig.daySelectSaturday,
            setDaySelected: () => setSabAttentionHour(!sabAttentionHour),
            isSelected: sabAttentionHour,
            dateDesde: sabDesde,
            dateHasta: sabHasta,
            setDateDesde: (value: string) => setSabDesde(value),
            setDateHasta: (value: string) => setSabHasta(value),
        },
        {
            dayLetter: onlineConfig.daySelectD,
            day: onlineConfig.daySelectSunday,
            setDaySelected: () => setDomAttentionHour(!domAttentionHour),
            isSelected: domAttentionHour,
            dateDesde: domDesde,
            dateHasta: domHasta,
            setDateDesde: (value: string) => setDomDesde(value),
            setDateHasta: (value: string) => setDomHasta(value),
        },
    ]
    const dateReceptionSelection: DayReception[] = [
        {
            dayLetter: 'L',
            day: 'Lunes',
            setDaySelected: () => setLunReceptionHour(!lunReceptionHour),
            isSelected: lunReceptionHour,
            dateDesde: receptionDesde,
            dateHasta: receptionHasta,
        },
        {
            dayLetter: 'M',
            day: 'Martes',
            setDaySelected: () => setMarReceptionHour(!marReceptionHour),
            isSelected: marReceptionHour,
            dateDesde: receptionDesde,
            dateHasta: receptionHasta,
        },
        {
            dayLetter: 'M',
            day: 'Miércoles',
            setDaySelected: () => setMierReceptionHour(!mierReceptionHour),
            isSelected: mierReceptionHour,
            dateDesde: receptionDesde,
            dateHasta: receptionHasta,
        },
        {
            dayLetter: 'J',
            day: 'Jueves',
            setDaySelected: () => setJueReceptionHour(!jueReceptionHour),
            isSelected: jueReceptionHour,
            dateDesde: receptionDesde,
            dateHasta: receptionHasta,
        },
        {
            dayLetter: 'V',
            day: 'Viernes',
            setDaySelected: () => setVieReceptionHour(!vieReceptionHour),
            isSelected: vieReceptionHour,
            dateDesde: receptionDesde,
            dateHasta: receptionHasta,
        },
        {
            dayLetter: 'S',
            day: 'Sábado',
            setDaySelected: () => setSabReceptionHour(!sabReceptionHour),
            isSelected: sabReceptionHour,
            dateDesde: receptionDesde,
            dateHasta: receptionHasta,
        },
        {
            dayLetter: 'D',
            day: 'Domingo',
            setDaySelected: () => setDomReceptionHour(!domReceptionHour),
            isSelected: domReceptionHour,
            dateDesde: receptionDesde,
            dateHasta: receptionHasta,
        },
    ]
    const dateConfig = (title: string, dateData: Day[]) => {
        return (
            <div>
                <Text
                    label={title}
                    variant="Subtitle2 grey900"
                    marginBottom={10}
                    marginTop={10}
                />

                <div className="daysContainer-sConfig">
                    {dateData.map((day: Day) => (
                        <div
                            key={day.day}
                            className={
                                day.isSelected
                                    ? 'dayContainerBlue-sConfig'
                                    : 'dayContainerGrey-sConfig'
                            }
                            style={{
                                pointerEvents: 'none',
                            }}
                        >
                            <Text label={day.dayLetter} variant="Subtitle2" />
                        </div>
                    ))}
                </div>
                {dateData.map(
                    (day: Day) =>
                        day.isSelected && (
                            <div key={day.day}>
                                <Text
                                    label={day.day}
                                    marginBottom={10}
                                    fontSize={9}
                                    fontWeight={400}
                                    color={'#565656'}
                                />
                                <div className="commonContainer-sConfig spaceBetween-sConfig">
                                    <div className="commonContainer-sConfig centered-sConfig spaceBetween-sConfig commonWidth-sConfig">
                                        <Text
                                            label={labels.sConfigDesde}
                                            fontSize={12}
                                            fontWeight={400}
                                            color={'#565656'}
                                        />
                                        <input
                                            placeholder={''}
                                            value={day.dateDesde}
                                            onChange={() => {
                                                console.log
                                            }}
                                            className={'placeholder-input'}
                                            disabled={true}
                                        />
                                    </div>

                                    <div className="commonContainer-sConfig centered-sConfig spaceBetween-sConfig commonWidth-sConfig">
                                        <Text
                                            label={labels.sConfigHasta}
                                            fontSize={12}
                                            fontWeight={400}
                                            color={'#565656'}
                                        />
                                        <input
                                            placeholder={''}
                                            value={day.dateHasta}
                                            onChange={() => {
                                                console.log
                                            }}
                                            className={'placeholder-input'}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="commonContainer-sConfig spaceBetween-sConfig ">
                                    <div className="divider-sConfig" />
                                    <div className="divider-sConfig" />
                                </div>
                            </div>
                        )
                )}
            </div>
        )
    }
    const dateReception = (title: string, dateData: DayReception[]) => {
        return (
            <>
                <div>
                    <Text
                        label={title}
                        variant="Subtitle2 grey900"
                        marginBottom={10}
                        marginTop={10}
                    />

                    <div className="daysContainer-sConfig">
                        {dateData.map((day: DayReception) => (
                            <div
                                key={day.day}
                                onClick={day.setDaySelected}
                                className={
                                    day.isSelected
                                        ? 'dayContainerBlue-sConfig'
                                        : 'dayContainerGrey-sConfig'
                                }
                                style={{
                                    pointerEvents: 'none',
                                }}
                            >
                                <Text
                                    label={day.dayLetter}
                                    variant="Subtitle2"
                                />
                            </div>
                        ))}
                    </div>
                    {lunReceptionHour ||
                    marReceptionHour ||
                    mierReceptionHour ||
                    jueReceptionHour ||
                    vieReceptionHour ||
                    sabReceptionHour ||
                    domReceptionHour ? (
                        <>
                            <Text
                                label={'Horario'}
                                marginBottom={10}
                                fontSize={9}
                                fontWeight={400}
                                color={'#565656'}
                            />
                            <div className="commonContainer-sConfig spaceBetween-sConfig">
                                <div className="commonContainer-sConfig centered-sConfig spaceBetween-sConfig commonWidth-sConfig">
                                    <Text
                                        label={labels.sConfigDesde}
                                        fontSize={12}
                                        fontWeight={400}
                                        color={'#565656'}
                                    />
                                    <input
                                        placeholder={''}
                                        value={receptionDesde}
                                        onChange={() => {
                                            console.log
                                        }}
                                        className={'placeholder-input'}
                                        disabled={true}
                                    />
                                </div>

                                <div className="commonContainer-sConfig centered-sConfig spaceBetween-sConfig commonWidth-sConfig">
                                    <Text
                                        label={labels.sConfigHasta}
                                        fontSize={12}
                                        fontWeight={400}
                                        color={'#565656'}
                                    />
                                    <input
                                        placeholder={''}
                                        value={receptionHasta}
                                        onChange={() => {
                                            console.log
                                        }}
                                        className={'placeholder-input'}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="commonContainer-sConfig spaceBetween-sConfig ">
                                <div className="divider-sConfig" />
                                <div className="divider-sConfig" />
                            </div>
                        </>
                    ) : null}
                </div>
            </>
        )
    }

    const getECommerce = async () => {
        try {
            await getCommerceInfo(commerceId).then((resp) => {
                if (resp.minimumAmount) {
                    const minammount = resp.minimumAmount.toString()
                    setAmmount(minammount)
                }
                if (resp.minimalAmountFreeDelivery) {
                    const minAmountDelivery =
                        resp.minimalAmountFreeDelivery.toString()
                    setMinAmount(minAmountDelivery)
                }
                setStoreCategory(resp.classification)

                const logoRefresh = `${resp.logo}?time=${new Date()}`
                setLogo(logoRefresh)

                setStoreDescription(resp.description)

                setSPhoneNumber('+' + resp.phone)
                setHasConsumerStore(resp.hasConsumeStore)
                setHasWithdrawal(resp.hasWithdrawal)
                setHasDelivery(resp.hasDelivery)
                setUrlAmimarket(resp.urlAmimarket)
                setAllDayDel(resp.allDay)
                setSEmailContacto(resp.email)
                setDeactive(resp.deactivateStoreTemp)
                setHasOnlineCommerce(resp.hasEcommerce)
                setCommerceSchedule(
                    state?.state?.commerceScheduled || resp.scheduledSale
                )
                if (resp.regionsDeliveries)
                    mapRegionsDeliveries(resp.regionsDeliveries)

                setLunAttentionHour(resp.attentionHours.lunes)
                setLunDesde(
                    resp.attentionHours.lunesInicio === ''
                        ? '00:00'
                        : resp.attentionHours.lunesInicio
                )
                setLunHasta(
                    resp.attentionHours.lunesCierre === ''
                        ? '00:00'
                        : resp.attentionHours.lunesCierre
                )
                setMarAttentionHour(resp.attentionHours.martes)
                setMarDesde(
                    resp.attentionHours.martesInicio === ''
                        ? '00:00'
                        : resp.attentionHours.martesInicio
                )
                setMarHasta(
                    resp.attentionHours.martesCierre === ''
                        ? '00:00'
                        : resp.attentionHours.martesCierre
                )
                setMierAttentionHour(resp.attentionHours.miercoles)
                setMierDesde(
                    resp.attentionHours.miercolesInicio === ''
                        ? '00:00'
                        : resp.attentionHours.miercolesInicio
                )
                setMierHasta(
                    resp.attentionHours.miercolesCierre === ''
                        ? '00:00'
                        : resp.attentionHours.miercolesCierre
                )
                setJueAttentionHour(resp.attentionHours.jueves)
                setJueDesde(
                    resp.attentionHours.juevesInicio === ''
                        ? '00:00'
                        : resp.attentionHours.juevesInicio
                )
                setJueHasta(
                    resp.attentionHours.juevesCierre === ''
                        ? '00:00'
                        : resp.attentionHours.juevesCierre
                )
                setVieAttentionHour(resp.attentionHours.viernes)
                setVierDesde(
                    resp.attentionHours.viernesInicio === ''
                        ? '00:00'
                        : resp.attentionHours.viernesInicio
                )
                setVierHasta(
                    resp.attentionHours.viernesCierre === ''
                        ? '00:00'
                        : resp.attentionHours.viernesCierre
                )
                setSabAttentionHour(resp.attentionHours.sabado)
                setSabDesde(
                    resp.attentionHours.sabadoInicio === ''
                        ? '00:00'
                        : resp.attentionHours.sabadoInicio
                )
                setSabHasta(
                    resp.attentionHours.sabadoCierre === ''
                        ? '00:00'
                        : resp.attentionHours.sabadoCierre
                )
                setDomAttentionHour(resp.attentionHours.domingo)
                setDomDesde(
                    resp.attentionHours.domingoInicio === ''
                        ? '00:00'
                        : resp.attentionHours.domingoInicio
                )
                setDomHasta(
                    resp.attentionHours.domingoCierre === ''
                        ? '00:00'
                        : resp.attentionHours.domingoCierre
                )

                if (resp.receptionHours) {
                    setLunReceptionHour(resp.receptionHours.lunes)
                    setMarReceptionHour(resp.receptionHours.martes)
                    setMierReceptionHour(resp.receptionHours.miercoles)
                    setJueReceptionHour(resp.receptionHours.jueves)
                    setVieReceptionHour(resp.receptionHours.viernes)
                    setSabReceptionHour(resp.receptionHours.sabado)
                    setDomReceptionHour(resp.receptionHours.domingo)

                    let tmpReceptionDesde = ''
                    let tmpReceptionHasta = ''
                    if (resp.receptionHours.lunesInicio) {
                        tmpReceptionDesde = resp.receptionHours.lunesInicio
                        tmpReceptionHasta = resp.receptionHours.lunesCierre
                    } else if (resp.receptionHours.martesInicio) {
                        tmpReceptionDesde = resp.receptionHours.martesInicio
                        tmpReceptionHasta = resp.receptionHours.martesCierre
                    } else if (resp.receptionHours.miercolesInicio) {
                        tmpReceptionDesde = resp.receptionHours.miercolesInicio
                        tmpReceptionHasta = resp.receptionHours.miercolesCierre
                    } else if (resp.receptionHours.juevesInicio) {
                        tmpReceptionDesde = resp.receptionHours.juevesInicio
                        tmpReceptionHasta = resp.receptionHours.juevesCierre
                    } else if (resp.receptionHours.viernesInicio) {
                        tmpReceptionDesde = resp.receptionHours.viernesInicio
                        tmpReceptionHasta = resp.receptionHours.viernesCierre
                    } else if (resp.receptionHours.sabadoInicio) {
                        tmpReceptionDesde = resp.receptionHours.sabadoInicio
                        tmpReceptionHasta = resp.receptionHours.sabadoCierre
                    } else if (resp.receptionHours.domingoInicio) {
                        tmpReceptionDesde = resp.receptionHours.domingoInicio
                        tmpReceptionHasta = resp.receptionHours.domingoCierre
                    }
                    setReceptionDesde(tmpReceptionDesde)
                    setReceptionHasta(tmpReceptionHasta)
                }
            })
        } catch (err) {
            setErrorComerceData(true)
            modalOpenScrollUp()
        }
    }
    const getTimeSlotOption = (hourRange: any) => {
        switch (hourRange) {
            case 24:
                return {
                    title: 'Máximo 24 horas (Entrega al día siguiente)',
                    setOption: 0,
                    hourRange: 24,
                }
            case 48:
                return {
                    title: 'Máximo 48 horas (Entrega en 2 días\ndespués de la compra)',
                    setOption: 1,
                    hourRange: 48,
                }
            case 72:
                return {
                    title: 'Máximo 72 horas (Entrega en 3 días\ndespués de la compra)',
                    setOption: 2,
                    hourRange: 72,
                }
            case 96:
                return {
                    title: 'Máximo 96 horas (Entrega en 4 días\ndespués de la compra)',
                    setOption: 3,
                    hourRange: 96,
                }
            case 120:
                return {
                    title: 'Máximo 120 horas (Entrega en 5 días\ndespués de la compra)',
                    setOption: 4,
                    hourRange: 120,
                }
        }
    }

    const getPickerValueReception = (dayReception: any) => {
        switch (dayReception) {
            case 1:
                return '1 día antes'
            case 2:
                return '2 días antes'
            case 0:
                return 'Mismo día'
            default:
                return null
        }
    }
    const mapRegionsDeliveries = (data: RegionType[]) => {
        const dataTmp = data
        const tempSelectedList: any = []
        const tempComunaList: any = []
        const tmp = dataTmp.map((item: any) => {
            tempSelectedList.push({
                NOMBRE: item.name,
                ID: item.name,
                regID: item.regionID,
                isDeleted: false,
                comunas: [],
            })
            const comunesTmp = item.communes.map((co: any) => {
                const timeSlotOption = getTimeSlotOption(co.hourRange)
                const pickerValueReception = getPickerValueReception(
                    co.dayReception
                )
                return {
                    comunaList: [
                        {
                            NOMBRE: co.communeName,
                            ID: co.communeID,
                            ID_REGION: item.name,
                            regID: item.regionID,
                            isDeleted: false,
                        },
                    ],
                    pickerValue: co.communeReference,
                    deliveryTime: co.hourLimit,
                    pickerValueReception: pickerValueReception,
                    costValue: co.communeDeliveryPrice,
                    optionSelected: timeSlotOption,
                    withinTheSameDayPickerValue: co?.typeDelivery
                        ? null
                        : co.communeDeliveryTime,
                    moreThanTwentyFourHr:
                        co.typeDelivery === 1 || co.typeDelivery === 2,
                    specificDays: co.typeDelivery === 2,
                    intheDayDelivery: co.sameDayDelivery,
                    selectedReceptionDays: co.dayReception,
                    daysSelection: [
                        {
                            dayLetter: 'L',
                            day: 'Lunes',
                            setDaySelected: 'daySelected()',
                            isSelected: co.monday,
                        },
                        {
                            dayLetter: 'M',
                            day: 'Martes',
                            setDaySelected: 'daySelected()',
                            isSelected: co.tuesday,
                        },
                        {
                            dayLetter: 'M',
                            day: 'Miércoles',
                            setDaySelected: 'daySelected()',
                            isSelected: co.wednesday,
                        },
                        {
                            dayLetter: 'J',
                            day: 'Jueves',
                            setDaySelected: 'daySelected()',
                            isSelected: co.thursday,
                        },
                        {
                            dayLetter: 'V',
                            day: 'Viernes',
                            setDaySelected: 'daySelected()',
                            isSelected: co.friday,
                        },
                        {
                            dayLetter: 'S',
                            day: 'Sábado',
                            setDaySelected: 'daySelected()',
                            isSelected: co.saturday,
                        },
                        {
                            dayLetter: 'D',
                            day: 'Domingo',
                            setDaySelected: 'daySelected()',
                            isSelected: co.sunday,
                        },
                    ],
                }
            })
            tempComunaList.push({
                ID: item.name,
                NOMBRE: item.name,
                isDeleted: false,
                regID: item.regionID,
                comunas: comunesTmp,
            })
        })
        setSelectedList(tempComunaList)
    }

    const modalOpenScrollUp = () => {
        if (containerRef.current) {
            containerRef.current.scrollIntoView({ behavior: 'smooth' })
            document.body.style.overflow = 'hidden'
        }
    }

    const handleOnChangePhone = (value: ChangeEvent<HTMLInputElement>) => {
        if (value.currentTarget.value.length < 3) {
            setSPhoneNumber('+56')
            return
        }
        const phoneTmp = '+56' + value.currentTarget.value.replace('+56', '')
        setSPhoneNumber(phoneTmp)
    }
    const navigateBack = () => {
        navigation(`/`)
    }

    const handleDescriptionInput = (value: any) => {
        setStoreDescription(value.target.value)
    }
    const handleNavigateToOnlineStorOB = () => {
        navigation(`/${routes.onlineStoreInformationScreen}`)
    }

    useEffect(() => {
        if (commerceId) {
            getECommerce()
        }
    }, [commerceId])

    return (
        <div className="background-sConfig">
            <div>
                <div
                    ref={containerRef}
                    className="innerContainer-sConfig"
                    id="innerContainer-SConfiguration"
                >
                    <div className="commonContainer-sConfig">
                        <img
                            src={arrowBack}
                            className="iconContainer-sConfig "
                            onClick={navigateBack}
                        />
                        <Text label={labels.sConfigTitle} variant="H5" />
                    </div>
                    <div className="storeNameContainer-sConfig">
                        <div className="store-logo-plus-container">
                            <img src={logo} className="logo-img-sConfig" />
                        </div>

                        <div className="textContainer-sConfig">
                            <Text
                                label={user?.cLocal[0]?.sNombreLocal}
                                variant="subtitle1 textStyle-sConfig "
                                marginBottom={20}
                            />

                            <Text
                                label={storeCategory}
                                variant="Small-2 storeCategoryTextStyle-sConfig"
                                marginBottom={6}
                            />
                            {features.drawer.config.eco_friendly && (
                                <div>
                                    <img
                                        src={ecoFriendlyIcon}
                                        style={{
                                            height: 18,
                                            width: 18,
                                            marginTop: 6,
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="editableInfoContainer-sConfig">
                        <Text
                            label={labels.sConfigDescription}
                            variant="subtitle2 grey900"
                            marginRight={20}
                        />
                        <div className="lineTitleStyle-sConfig" />
                    </div>
                    <textarea
                        placeholder={''}
                        value={storeDescription}
                        onChange={handleDescriptionInput}
                        className={'inputStyle-sConfig'}
                        disabled={descriptionDisabled}
                    />
                    <div className="editableInfoContainer-sConfig">
                        <Text
                            label={labels.sConfigPhone}
                            fontWeight={600}
                            fontSize={12}
                            color={'#565656'}
                            style={{ width: 155 }}
                        />

                        <input
                            maxLength={12}
                            placeholder={''}
                            value={sPhoneNumber}
                            onChange={handleOnChangePhone}
                            className={'inputPhoneStyle-sConfig'}
                            disabled={phoneDisabled}
                            style={{
                                textAlign: 'center',
                                width: 120,
                            }}
                        />
                        <div className="lineTitleStyle-sConfig" />
                    </div>
                    <div className="storeColumn-sConfig">
                        <div className="commonColumnContainer-sq commonMarginLeft">
                            <Text
                                label={labels.sConfigFisicalStore}
                                variant="subtitle1 grey900 "
                                marginTop={20}
                            />
                            {dateConfig('Horario de atención', dateSelection)}
                            <div className="commonHeight" />

                            <SquareCheckBox
                                checkId="consumerStore-id"
                                labelClassName="Body3-12 "
                                label={'Consumo en local'}
                                subtitle="Los clientes pueden comer en mis instalaciones."
                                onClick={() => console.log}
                                checked={hasConsumerStore}
                            />
                        </div>

                        {features.marketplace && (
                            <div className="onlineContainer-sq">
                                {hasOnlineCommerce && (
                                    <Text
                                        label={labels.sConfigOnlineStore}
                                        variant="subtitle1 grey900 "
                                        marginTop={20}
                                    />
                                )}
                                {!hasOnlineCommerce ? (
                                    <>
                                        {/* <div className="noOnlineStoreContainer-sConfig">
																				<img
																						src={info}
																						className="infoIcon-sConfig"
																				/>
																				<Text
																						label={
																								labels.sConfigNoOnlineStore
																						}
																						variant="Subtitle2 grey900"
																				/>
																		</div> */}
                                        {/* <div
																			className="greenButton-sConfig"
																			onClick={
																				handleNavigateToOnlineStorOB
																			}
																		>
																			<Text
																				label={
																					labels.sConfigUpdateStoreButton
																				}
																				variant="Subtitle2"
																			/>
																		</div> */}
                                    </>
                                ) : (
                                    <div>
                                        {!allDayDel &&
                                            dateReception(
                                                'Horarios de recepción de pedidos',
                                                dateReceptionSelection
                                            )}
                                        <div className="commonHeight" />
                                        <SquareCheckBox
                                            checkId="reception24-7"
                                            labelClassName="Body3-12 "
                                            label={'Recepción de pedidos 24/7 '}
                                            onClick={() => console.log}
                                            checked={allDayDel}
                                        />
                                        <div className="editableInfoContainer-sConfig ">
                                            <Text
                                                label={labels.sConfigEmail}
                                                variant="subtitle3 grey900"
                                            />
                                            <textarea
                                                placeholder={''}
                                                value={sEmailContacto}
                                                className={
                                                    'inputEmailStyle-sConfig '
                                                }
                                                disabled
                                            />

                                            <div>
                                                <Text
                                                    label={labels.editProduct}
                                                    variant="Small-2 grey900 hasPointer-sConfig"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
